var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9844 5C6.70585 5 1.25 9.34459 1.25 14.7057C1.25 20.0655 6.70585 24.4107 14.9844 24.4107C23.2642 24.4107 28.7213 20.0655 28.7213 14.7057C28.7213 9.34459 23.2642 5 14.9844 5Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4321 18.3324C19.7905 17.923 27.7538 16.2842 26.7727 11.74C26.4195 10.1101 24.7428 8.31715 22.2133 7.07069C20.1916 6.16096 17.724 5.63281 14.9525 5.63281C7.26654 5.63281 1.92188 9.69438 1.92188 14.7055C1.92188 18.1953 4.5165 21.2252 8.68862 22.7414C9.57371 20.4115 13.0989 19.0842 17.4321 18.3324Z",
    fill: "#0075C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.001 19.9398C11.5548 20.3725 9.97353 21.4857 8.95703 22.8377C10.7133 23.4385 12.7343 23.7771 14.9518 23.7771C22.6384 23.7771 27.983 19.7168 27.983 14.7057C27.983 14.2616 27.9407 13.825 27.8586 13.3979C27.604 19.2815 18.772 19.4717 15.001 19.9398Z",
    fill: "url(#paint0_linear_3925_19814)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1806 17.1781C18.142 16.7523 18.1262 16.4617 18.1262 16.2115V13.6693H16.9019L16.941 13.7476C16.9423 13.7495 17.0655 13.9934 17.0655 14.5266L17.0655 14.5312C17.0657 14.6315 17.0687 16.3034 17.0206 16.7074C16.725 16.7832 16.3295 16.8104 16.073 16.8104C14.1304 16.8104 13.1442 15.6947 13.1442 13.4968C13.1442 11.8189 14.2542 10.5661 15.8424 10.4511C16.6782 10.3918 17.4825 10.6192 17.9891 11.0589L18.0776 11.136V10.1087L18.0352 10.1005C17.5305 10.0032 16.9379 9.90088 16.3579 9.90088C13.5611 9.90088 11.8902 11.3735 11.8902 13.8393C11.8902 16.4661 13.9301 17.4017 15.8399 17.4017C16.6492 17.4017 17.4863 17.3417 18.1363 17.2349L18.185 17.2267L18.1806 17.1781ZM6.18875 10.6174C6.33721 10.6048 6.79208 10.5719 7.12122 10.5719C9.08915 10.5719 10.0071 11.5259 10.0071 13.5747C10.0071 15.6917 9.19149 16.7221 7.51544 16.7221C6.28857 16.7221 6.18875 16.6627 6.18875 15.9356V10.6174ZM7.53558 9.96794H4.95801L4.98833 10.0419C5.10268 10.3198 5.09573 10.8265 5.08815 11.275C5.08499 11.3805 5.08373 17.2256 5.08373 17.2256L5.1349 17.2268C5.1469 17.2281 6.30934 17.2698 7.41112 17.2698C9.71324 17.2698 11.2604 15.7093 11.2604 13.387C11.2604 11.3098 9.79853 9.96794 7.53558 9.96794ZM21.2481 10.5375H20.5279L20.5241 13.0248H20.9941C22.2703 13.0248 22.8647 12.599 22.8647 11.6842C22.8647 10.8806 22.3827 10.5375 21.2481 10.5375ZM21.0927 13.5947H20.5241V15.9859C20.5241 16.5153 20.7477 16.7219 21.3195 16.7219C22.4989 16.7219 23.0726 16.2 23.0726 15.1273C23.0726 14.1102 22.408 13.5947 21.0927 13.5947ZM23.9198 11.5364C23.9198 12.4372 23.2501 13.0545 22.5501 13.2408C23.6058 13.467 24.3241 14.1942 24.3241 15.0622C24.3241 16.4647 23.2615 17.2696 21.4086 17.2696C20.4342 17.2696 19.6322 17.2839 19.4982 17.2863C19.4859 17.2865 19.4793 17.2866 19.4785 17.2866L19.4242 17.2879V10.9943C19.4242 10.3253 19.3604 10.0359 19.3591 10.0328L19.3446 9.96771H21.5494C23.0347 9.96771 23.9198 10.5533 23.9198 11.5364Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3925_19814",
    x1: 28.9989,
    y1: 16.4201,
    x2: 9.71623,
    y2: 17.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AB935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305922,
    stopColor: "#00A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669783,
    stopColor: "#008AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/하이투자증권-30.8439b4d4955f6d0baafad5b7a8fe318f.svg";
export { ForwardRef as ReactComponent };